import {BASE_API_URL, BASE_URL} from '../app.globals';

export const chargeUrl = BASE_API_URL + 'chargeto';
export const coordinatorsUrl = BASE_API_URL + 'coordinators';
export const departmentsUrl = BASE_API_URL + 'departments';
export const groupsActiveUrl = BASE_API_URL + 'groups-active';
export const groupsAllUrl = BASE_API_URL + 'groups-all';
export const filesUrl = BASE_API_URL + 'files';
export const formatsUrl = BASE_API_URL + 'formats';
export const formatsActiveUrl = BASE_API_URL + 'formats-active';
export const importanceUrl = BASE_API_URL + 'importance';
export const locationsUrl = BASE_API_URL + 'locations';
export const locationsActiveUrl = BASE_API_URL + 'locations-active';
export const namesUrl =  BASE_API_URL + 'people-names';
export const oswUrl = BASE_API_URL + 'osw';
export const peopleUrl =  BASE_API_URL + 'people';
export const projectsUrl =  BASE_API_URL + 'projects';
export const projectsActiveUrl =  BASE_API_URL + 'projects-active';
export const proposalsUserUrl =  BASE_API_URL + 'user-proposals';
export const proposalsUrl =  BASE_API_URL + 'proposals';
export const proposalsEmailUrl =  BASE_API_URL + 'proposals-email';
export const proposalsStatusUrl =  BASE_API_URL + 'proposals-status';
export const purposesUrl =  BASE_API_URL + 'purposes';
export const recordGroupsUrl = BASE_API_URL + 'groups-records';
export const recordsUserGroupsUrl = BASE_API_URL + 'groups-users';
export const recordsUrl = BASE_API_URL + 'records';
export const recordsUserUrl = BASE_API_URL + 'user-records';
export const reportsUrl = BASE_API_URL + 'reports';
export const reposUrl = BASE_API_URL + 'repos';
export const rolesUrl = BASE_API_URL + 'roles';
export const storageUrl = BASE_API_URL + 'storage';
export const utilsUrl = BASE_API_URL + 'utils';
export const uploaderUrl = BASE_URL + 'uploader';
export const worktypesUrl = BASE_API_URL + 'worktypes';
export const worktypesActiveUrl = BASE_API_URL + 'worktypes-active';
